/** Browser event emitted after the singleton PostHog client has finished initialization. */
export const POSTHOG_CLIENT_READY_EVENT = 'kor:posthog-client-ready';

/** Signals hooks that mounted before PostHog initialization to retry client-dependent work. */
export function announcePostHogClientReady(): void {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(POSTHOG_CLIENT_READY_EVENT));
  }
}
